import React from 'react'
import RoundedIcon from 'components/atoms/RoundedIcon'
import './styles.scss'

interface SimpleCardWithIconProps {
  title: string
  description?: string | JSX.Element | null | undefined
  icon?: string
}

const SimpleCardWithIcon = ({
  title = 'Title',
  description = 'Description',
  icon = 'help'
}: SimpleCardWithIconProps): JSX.Element => {
  return (
    <div className='ui-simple-card'>
      <RoundedIcon icon={icon} />
      <div className='ui-simple-card-body'>
        <p>{title}</p>
        <span style={{ lineHeight: '1.2em' }}>{description}</span>
      </div>
    </div>
  )
}

export default SimpleCardWithIcon
